import { render } from "./ThongTinChieuDi.vue?vue&type=template&id=7c9d6fa1&scoped=true"
import script from "./ThongTinChieuDi.vue?vue&type=script&lang=js"
export * from "./ThongTinChieuDi.vue?vue&type=script&lang=js"

import "./ThongTinChieuDi.vue?vue&type=style&index=0&id=7c9d6fa1&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9d6fa1"]])

export default __exports__